function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#tick_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.6 14c0 6.067 4.805 10.889 10.85 10.889 4.96 0 9.3-3.422 10.54-8.4l2.945.778C26.385 23.644 20.96 28 14.45 28 6.7 28 .5 21.778.5 14S6.7 0 14.45 0c2.945 0 5.89.933 8.37 2.8l-1.86 2.489a10.924 10.924 0 00-6.51-2.178C8.405 3.111 3.6 7.933 3.6 14zm6.665-2.8l2.17-2.178 5.425 5.6 11.47-11.51 2.17 2.177-13.64 13.689-7.595-7.778z",
  fill: "#C08B4A"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "tick_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.5)",
  d: "M0 0h31v28H0z"
})));

function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 28"
  }, props), _ref, _ref2);
}

export default SvgTick;